import React from 'react';

export default function SponsorsRouteInterceptor(props) {
  return (
    <main className="site--width">
      <div>Loading...</div>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/components/SponsorsRouteInterceptor/index.js